import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';

interface MessageFormatterProps {
  text: string;
  isUser: boolean;
}

export const MessageFormatter = memo<MessageFormatterProps>(({ text, isUser }) => {
  if (isUser) {
    return (
      <Typography variant="body2" sx={{ wordBreak: 'break-word', lineHeight: 1.5 }}>
        {text}
      </Typography>
    );
  }

  // Simple formatting for bot messages - just basic text display
  return (
    <Typography variant="body2" sx={{ wordBreak: 'break-word', lineHeight: 1.6 }}>
      {text}
    </Typography>
  );
});

MessageFormatter.displayName = 'MessageFormatter';
